<template>
 <!-- 头部整体盒子 -->
  <div class="header-top">
    <!-- 电脑导航 -->
      <!-- 导航logo -->
      <div class="header-left">
        <img src="@/assets/img/img_logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="nav">
        <li v-for="(item,index) in navList" :key="index" @click="navClick(index,item.name)" >
        <router-link :to="item.path" custom v-slot="{navigate, isActive}" >
          <a :active="isActive" :class="navIndex==index && isActive?'active':'scroll'" @click="navigate">{{item.name}}</a>
          <!-- <a :active="isActive" :class="isExactActive?'active':'scroll'" @click="navigate">{{item.name}}</a> -->
        </router-link>
        </li>
      </ul>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "公司介绍",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "加入我们",
          path: "/jobchance",
          children: []
        },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    }
  }
};
</script>
<style scoped>
/*-- header-top --*/
.header-top {
  /* padding: 1em 0; */
  height: 62px;
	position: absolute;
	width: 100%;
  background: rgba(0, 0, 0, 0.5);
	z-index: 1;
}
.header-left {
    margin-left: 25%;
    align-items:center;
	  float:left;
}

.nav {
	display: inline-block;
	margin: 0px 0px ;
	margin-left: 5%;
}
.nav > li {
  float: left;
	display: inline-block;
	position: relative;
}

.nav > li::after{
	content: '';
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 0;
	background: #883231 !important;
	-webkit-transition: all 0.3s;
	-moz-transition: all 0.3s;
	-ms-transition: all 0.3s;
	-o-transition: all 0.3s;
	transition: all 0.3s;
	z-index: -1;
}
.nav > li > a {
    display: block;
    font-size: 20px;
    padding: 18px 0;
    text-shadow: 1px 1px 0 #000;
    color: #d5d5d5;
    text-align: center;
    width: 150px;
	  text-decoration: none;
}

.nav > li:hover::after {
	height: 100%;
}
.nav  li .active {
	background-color: #883231;
	color: #fff!important;
	position: relative;
	text-shadow:0 0 0 #000!important;
}
.active span {
	color: #fff!important;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue